// extracted by mini-css-extract-plugin
export var header = "_x4-1";
export var maskBottom = "_x4-6";
export var maskMiddle = "_x4-7";
export var maskTop = "_x4-5";
export var root = "_x4-0";
export var scrollDownButton = "_x4-3";
export var scrollDownButtonHidden = "_x4-4";
export var viewport = "_x4-2";